import axios from "axios";

export default {
  fetchTestQuestions: async testId => {
    const response = await axios.get('/api/tests/' + testId + '/questions');
    return response.data;
  },
  fetchTestQuestionsFull: async testId => {
    const response = await axios.get('/api/admin/tests/' + testId + '/questions');
    return response.data;
  },
  getQuestion: async (testId, questionId) => {
    const response = await axios.get('/api/questions/' + questionId);
    return response.data;
  },
  getQuestionFull: async questionId => {
    const response = await axios.get('/api/admin/questions/' + questionId);
    return response.data;
  },
  createQuestion: async form => {
    const { data } = await form.post('/api/admin/questions/create');
    return data;
  },
  updateQuestion: async form => {
    const { data } = await form.patch('/api/admin/questions/' + form.id);
    return data;
  },
  removeQuestion: async id => {
    const response = await axios.delete('/api/admin/questions/' + id);
    return response.data;
  }
};
